import { useState } from "react";
import { Link } from "react-router-dom";
import CaseCard from "@/components/feature/CaseCard";
import { cases, caseCategories } from "@/mocks/cases";

const tabs = ["全部", ...caseCategories];

export default function PicksSection() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? cases : cases.filter((item) => item.category === active);
  const [lead, ...rest] = list;

  return (
    <section id="picks" className="scroll-mt-12 w-full border-b border-background-200 py-12 md:py-16">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-[11px] font-medium tracking-[0.24em] text-secondary-500">ARCHIVE</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">案例精选</h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
              每个案例都按同一套结构整理：正序时间线、双方回应、舆论风向变化、逐条澄清与最终观察结论。
            </p>
          </div>
          <Link
            to="/cases"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
          >
            查看全部档案
            <i className="ri-arrow-right-line text-base" aria-hidden="true" />
          </Link>
        </div>

        <div className="mt-7 flex flex-wrap items-center gap-2 border-y border-background-200 py-3">
          {tabs.map((tab) => {
            const isActive = active === tab;
            const count = tab === "全部" ? cases.length : cases.filter((item) => item.category === tab).length;
            return (
              <button
                key={tab}
                type="button"
                onClick={() => setActive(tab)}
                aria-pressed={isActive}
                className={[
                  "flex items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs transition-colors",
                  isActive
                    ? "bg-primary-800 font-medium text-background-50"
                    : "text-foreground-600 hover:bg-background-100 hover:text-foreground-900",
                ].join(" ")}
              >
                {tab}
                <span className={isActive ? "text-background-300" : "text-foreground-400"}>{count}</span>
              </button>
            );
          })}
        </div>

        {list.length === 0 ? (
          <p className="mt-8 rounded-lg border border-dashed border-background-300 px-5 py-12 text-center text-sm text-foreground-500">
            这个分类暂时还没有归档案例，换个分类看看？
          </p>
        ) : (
          <>
            {lead && (
              <article className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:grid lg:grid-cols-12">
                <Link to={`/cases/${lead.slug}`} className="block lg:col-span-6">
                  <div className="h-56 w-full overflow-hidden bg-background-200 lg:h-full lg:min-h-[280px]">
                    <img
                      src={lead.cover}
                      alt={`${lead.title}案例配图`}
                      title={`${lead.title} - 瓜田黑料重点档案`}
                      className="h-56 w-full object-top lg:h-full lg:min-h-[280px]"
                    />
                  </div>
                </Link>
                <div className="flex flex-col justify-center p-5 lg:col-span-6 lg:p-8">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-900">
                      {lead.category}
                    </span>
                    <span className="rounded-full bg-primary-100 px-2.5 py-1 text-[11px] font-medium text-primary-800">
                      {lead.status}
                    </span>
                  </div>
                  <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                    <Link to={`/cases/${lead.slug}`} className="transition-colors hover:text-primary-700">
                      {lead.title}
                    </Link>
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{lead.summary}</p>
                  <ul className="mt-5 flex flex-wrap gap-2">
                    {lead.tags.map((tag) => (
                      <li
                        key={tag}
                        className="rounded-md border border-background-300 px-2.5 py-1 text-[11px] text-foreground-600"
                      >
                        #{tag}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-[11px] text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line text-sm" aria-hidden="true" />
                      更新于 {lead.updatedDate}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line text-sm" aria-hidden="true" />
                      {lead.readTime}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-sm text-accent-500" aria-hidden="true" />
                      热度 {lead.heat}
                    </span>
                  </div>
                </div>
              </article>
            )}

            {rest.length > 0 && (
              <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {rest.slice(0, 6).map((item, index) => (
                  <CaseCard key={item.id} item={item} rank={index + 2} />
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
}